import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ILoaderState } from '@app/shared/models/ILoaderState';


@Injectable()
export class LoaderService {

  private loaderSubject = new Subject<ILoaderState>();

  loaderState = this.loaderSubject.asObservable();

  constructor() { }

  show() {
    this.loaderSubject.next(<ILoaderState>{show: true});
  }

  hide() {
    this.loaderSubject.next(<ILoaderState>{show: false});
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/loader.service.ts